import { IAppState } from '../../redux';

export const selectIsByHomeowner = (state: IAppState): boolean => {
  return state.offer.isByHomeowner;
};
